/** A record panel's field grid (the Zero-Re-Layout Rule, DESIGN.md §5): as many 232 px
 *  field columns as the panel's EDIT-mode width fits, pinned through `FIELD_GRID_VAR` on
 *  an ancestor so entering edit mode — or docking the ledger — never moves a field to
 *  another row. */

/** The narrowest an edit-mode input gets: room for a real email, phone, departure code
 *  or select value beside its end adornment — three columns at 1440 px beside the docked
 *  ledger. */
const FIELD_MIN_PX = 232;
const FIELD_GAP_PX = 16;
/** The SectionCard's padding and border, both sides. */
export const PANEL_INSET_PX = 2 * 16 + 2;

/** Set on a panel's ancestor to pin its field grids' column count (`fieldGridColumns`). */
export const FIELD_GRID_VAR = '--record-field-grid';

/** Field grid: as many `FIELD_MIN_PX` columns as fit — or the count `FIELD_GRID_VAR`
 *  pins; wide fields take the row. */
export const FIELD_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: `var(${FIELD_GRID_VAR}, repeat(auto-fill, minmax(${FIELD_MIN_PX}px, 1fr)))`,
  columnGap: `${FIELD_GAP_PX}px`,
  rowGap: 0.5,
  alignItems: 'start',
} as const;

/** The `FIELD_GRID_VAR` value for panels `panelWidth` px wide: as many `FIELD_MIN_PX`
 *  columns as fit. */
export function fieldGridColumns(panelWidth: number): string {
  const n = Math.max(1, Math.floor((panelWidth - PANEL_INSET_PX + FIELD_GAP_PX) / (FIELD_MIN_PX + FIELD_GAP_PX)));
  return `repeat(${n}, minmax(0, 1fr))`;
}
